
import type { SVGProps } from 'react';
const SvgTeeSpezialitaeten = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={24}
    height={24}
    fill="none"
    {...props}
  >
    <g clipPath="url(#tee-spezialitaeten_svg__a)">
      <path
        fill="#263E6A"
        d="M9.628 5.59c.015-.166.103-.404.433-.593.072-.04.16-.105.166-.177.01-.108-.117-.273-.207-.35a.267.267 0 0 1 .346-.407c.044.038.432.38.393.805-.016.166-.103.404-.433.593-.072.041-.16.106-.167.178-.01.113.132.285.207.349a.267.267 0 1 1-.345.407c-.045-.038-.432-.38-.393-.805m2.291.805a.266.266 0 0 0 .377-.031.267.267 0 0 0-.031-.376c-.075-.064-.217-.236-.207-.349.007-.072.095-.137.167-.178.33-.189.417-.427.433-.593.039-.425-.349-.767-.393-.805a.266.266 0 1 0-.346.408c.075.063.217.236.207.348-.007.073-.094.137-.166.178-.33.19-.418.427-.433.593-.04.426.348.767.393.805m5.754 5.614a2.54 2.54 0 0 1-1.744 2.161.267.267 0 1 1-.165-.508 2.01 2.01 0 0 0 1.378-1.707 2.02 2.02 0 0 0-1.504-2.147l-.644 6.675a1 1 0 0 1-.123.398h1.357a.267.267 0 0 1 .246.371l-.431 1.024a1.18 1.18 0 0 1-1.09.724h-7.41a1.18 1.18 0 0 1-1.09-.724l-.432-1.024a.267.267 0 0 1 .492-.207l.431 1.024a.65.65 0 0 0 .598.397h7.41a.65.65 0 0 0 .598-.397l.276-.654H8.433c-.534 0-.975-.4-1.027-.932L6.62 8.326a1.033 1.033 0 0 1 1.026-1.13h7.109a1.033 1.033 0 0 1 1.026 1.13l-.091.946a2.553 2.553 0 0 1 1.983 2.737M7.83 15.31h6.74l.127-1.316.437-4.527.018-.182h-6.4a.267.267 0 0 1 0-.533h6.451l.046-.478a.5.5 0 0 0-.126-.382.5.5 0 0 0-.368-.163h-7.11a.5.5 0 0 0-.367.163.5.5 0 0 0-.127.382zm6.137 1.57c.258 0 .47-.193.495-.449l.057-.587H7.881l.057.587c.025.256.237.45.495.45h5.534"
      />
    </g>
    <defs>
      <clipPath id="tee-spezialitaeten_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgTeeSpezialitaeten;
